import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import Image from 'next/image';
import { customImageLoader } from '@restworld/utils-common';
import { PhotoIcon } from '@heroicons/react/24/solid';
import { jsx as _jsx } from "react/jsx-runtime";
export function ImageSlider(_ref) {
  var images = _ref.images;
  if (!images || !images.length) return /*#__PURE__*/_jsx(Placeholder, {});
  return /*#__PURE__*/_jsx(SliderGallery, {
    images: images
  });
}

var SliderGallery = function SliderGallery(_ref2) {
  var images = _ref2.images;
  return /*#__PURE__*/_jsx(SliderWrapper, {
    children: images !== null && images !== void 0 && images.length ? images.map(function (v) {
      return /*#__PURE__*/_jsx(ImageStyled, {
        width: 235,
        height: 132,
        src: v
      }, v);
    }) : null
  });
};

var Placeholder = function Placeholder() {
  return /*#__PURE__*/_jsx(_StyledDiv, {
    children: /*#__PURE__*/_jsx(_StyledPhotoIcon, {})
  });
};

var SliderWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "image-slider__SliderWrapper",
  componentId: "sc-u9izx4-0"
})({
  "display": "flex",
  "height": "100%",
  "maxWidth": "100%",
  "gap": "0.5rem",
  "overflowX": "auto",
  "scrollbarWidth": "none",
  "::-webkit-scrollbar": {
    "display": "none"
  }
});

var ImageStyled = /*#__PURE__*/_styled(function (props) {
  return /*#__PURE__*/_jsx(Image, _objectSpread({
    loader: customImageLoader,
    alt: ""
  }, props));
}).withConfig({
  displayName: "image-slider__ImageStyled",
  componentId: "sc-u9izx4-1"
})(["", " ", ""], {
  "display": "block",
  "height": "8rem",
  "width": "100%",
  "minWidth": "fit-content",
  "borderRadius": "0.5rem",
  "objectFit": "cover",
  "objectPosition": "center"
}, function (_ref3) {
  var $customStyle = _ref3.$customStyle;
  return $customStyle;
});

export default ImageSlider;

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "image-slider___StyledDiv",
  componentId: "sc-u9izx4-2"
})({
  "display": "grid",
  "height": "8rem",
  "width": "100%",
  "placeItems": "center",
  "borderRadius": "0.5rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(208 192 234 / var(--tw-bg-opacity))"
});

var _StyledPhotoIcon = /*#__PURE__*/_styled(PhotoIcon).withConfig({
  displayName: "image-slider___StyledPhotoIcon",
  componentId: "sc-u9izx4-3"
})({
  "height": "2rem",
  "width": "2rem",
  "fill": "#492983"
});